// new stuff goes here.
import Axios from 'axios'
import { FARMDECK_API, RESOURCE_API } from 'app-config/index.js'
import { accountId } from 'helpers/account.js'
import { produce } from 'immer'
import * as actionTypes from 'redux/actions/action-types.js'

/**
 * Resolved per call, never at module load. `accountId` reads the page's path for a master user, so a
 * constant built when this module loaded is frozen to whatever page was open then (`/auth/login`, or the
 * first tenant visited) and every later write goes there.
 */
const baseUrl = () => FARMDECK_API.replace(':id', accountId)
export const cancelSource = Axios.CancelToken.source()
export const apiRequest = async ({ method = 'get', endpoint = 'assets/', url = '', data = null, params = null, dispatch = null }) => {
    try {
        const response = await Axios({
            method,
            url: `${baseUrl()}${endpoint}${url}`,
            data,
            params,
            cancelToken: cancelSource.token,
        })
        // TODO - instead of checking if the response is not empty OR if the response code is NoContent
        // maybe do this instead -
        // if (dispatch && response.ok) {
        if (dispatch && (response.data || response.status === 204)) {
            dispatch(
                // Adding this toLowerCase for safety, as the fallback condition on no match is 'delete'
                // this can throw a nasty surprise !!  eg POST -> delete !!
                updateAssetStore({
                    type: method.toLowerCase() === 'post' ? 'add' : method === 'put' ? 'update' : 'delete',
                    data: response.data || { id: url },
                    section: endpoint.replace(/\//g, ''),
                }),
            )
        }

        return Promise.resolve(response.data)
    } catch (error) {
        if (Axios.isCancel(error)) {
            console.error('Request cancelled:', error.message)
        } else {
            console.error('API request failed:', error)
        }
        if (error?.response?.status === 404) {
            if (dispatch) {
                dispatch(
                    updateAssetStore({
                        type: 'delete',
                        data: { id: parseInt(url) },
                        section: endpoint.replace(/\//g, ''),
                    }),
                )
            }
        }

        return Promise.reject(error)
    }
}

export function updateAssetStore(payload) {
    return (dispatch, getState) => {
        const state = getState()
        const nextState = produce(state, draft => {
            const items = draft[payload.section].data.items ?? []
            switch (payload?.type) {
                case 'update': {
                    const index = items.findIndex(item => item.id === payload.data.id)
                    if (index !== -1) {
                        draft[payload.section].data.items[index] = { ...items[index], ...payload.data }
                    }
                    break
                }
                case 'add': {
                    draft[payload.section].data.items.push(payload.data)
                    break
                }
                case 'delete': {
                    draft[payload.section].data.items = items.filter(item => item.id !== payload.data.id)
                    break
                }
                default:
                // handle other types
            }
        })

        let actionType
        switch (payload.section) {
            case 'assets':
                actionType = actionTypes.FD_ASS_REQUEST_SUCCESS
                break
            case 'paddocks':
                actionType = actionTypes.FD_PAD_REQUEST_SUCCESS
                break
            default:
                break
        }

        dispatch({
            type: actionType,
            action: payload?.type,
            data: nextState[payload.section].data,
            account: state.account,
        })
    }
}
export const recordsAPIRequest = async ({ method = 'get', endpoint = '', body = null, queryParams = null, filter = null } = {}) => {
    try {
        const response = await Axios({
            method,
            url: `${baseUrl()}${endpoint}`,
            data: body,
            params: queryParams,
            cancelToken: cancelSource.token,
        })

        if (filter && typeof filter === 'function' && response?.data?.items) {
            return Promise.resolve(filter(response.data.items))
        }

        return Promise.resolve(response.data)
    } catch (error) {
        if (Axios.isCancel(error)) {
            console.error('Request cancelled:', error.message)
        } else {
            console.error('API request failed:', error)
        }
        return Promise.reject(error)
    }
}

export const resourceAPIRequest = async ({ method = 'post', endpoint = '?action=download', body = null, queryParams = null, tenant } = {}) => {
    const resourceURL = RESOURCE_API.replace(':id', tenant)
    // console.log('resource API Request', {
    //     method,
    //     url: `${resourceURL}${endpoint}`,
    //     data: body,
    //     params: queryParams,
    //     cancelToken: cancelSource.token,
    // })
    try {
        const response = await Axios({
            method,
            url: `${resourceURL}${endpoint}`,
            data: body,
            params: queryParams,
            cancelToken: cancelSource.token,
        })
        return Promise.resolve(response.data)
    } catch (error) {
        if (Axios.isCancel(error)) {
            console.error('Request cancelled:', error.message)
        } else {
            console.error('API request failed:', error)
        }
        return Promise.reject(error)
    }
}
